<template>
    <v-container >
        <div v-if="success" class="d-flex flex-column justify-space-between align-center">
            <v-img
            :src="require('../assets/check-icon.png')"
            class="my-10"
            contain
            height="156"
            width="156"
            />
            <h1>Thank You!</h1>
            <p></p>
            <h3 style="color: #962283" class="display-0 font-weight-bold mb-1">
                Your Reference is:
            </h3>
            <p></p>
            <h3>{{charge_token}}</h3>
            <p></p>
            <h3 style="color: #962283" class="display-0 font-weight-bold mb-1">
                Click View My Tickets to see Tickets
            </h3>
        </div>
        <div v-if="processing" >
            <p></p>
            <h3 v-if="!Testing" class="d-flex flex-column justify-space-between align-center" style="color: red">
                Visa and Master Card Payments Only !
            </h3>
            <h3 v-if="Testing" class="d-flex flex-column justify-space-between align-center" style="color: red">
                Testing Card Payments Only !
            </h3>
            <p></p>
            <!-- class="d-flex flex-column justify-space-between align-center"> -->
            <strong class="d-flex flex-column justify-space-between align-center" style="color: green">Amount to Pay:  $ {{amount}}  AUD</strong>
            <strong class="d-flex flex-column justify-space-between align-center" style="color: blue">{{payment.description}}</strong>
            <p></p>
          <v-form ref="Payment" lazy-validation>
            <v-row no-gutter dense>
                <v-col cols="12">
                    <v-text-field
                    outlined
                    dense
                    v-model="payment.card.name"
                    label="Name on Card"
                    :rules="[(v) => !!v || 'Cardholder Name is required']"
                    @input="payment.card.name = capitalizeFirstLetter(payment.card.name)"
                    ></v-text-field>
                </v-col>
                <v-col cols="6">
                    <v-text-field
                    outlined
                    dense
                    v-model="number"
                    label="Card Number"
                    v-mask="'#### #### #### ####'"
                    :rules="[rules.required, rules.cardnumber]"
                    ></v-text-field>
                </v-col>
                <v-col cols="3">
                    <v-text-field
                    outlined
                    dense
                    v-model="expiry"
                    label="Expiry"
                    v-mask="'## / ##'"
                    :rules="[rules.required, rules.expiry]"
                    ></v-text-field>
                </v-col>
                <v-col cols="3">
                    <v-text-field
                    outlined
                    dense
                    v-model="cvc"
                    label="CVC"
                    v-mask="'###'"
                    :rules="[rules.required, rules.cvc]"
                    ></v-text-field>
                </v-col>
                <v-col cols="12">
                    <v-text-field
                        outlined
                        dense
                        v-model="payment.email"
                        label="Email Address"
                        :rules="[rules.required, rules.email]"
                    ></v-text-field>
                </v-col>
                <v-col cols="12">
                    <v-text-field
                    outlined
                    dense
                    v-model="payment.card.address_line1"
                    label="Address"
                    :rules="[(v) => !!v || 'Address is required']"
                    @input="payment.card.address_line1 = capitalizeFirstLetter(payment.card.address_line1)"
                    ></v-text-field>
                </v-col>
                <v-col cols="6">
                    <v-text-field
                    outlined
                    dense
                    v-model="payment.card.address_city"
                    label="City"
                    :rules="[(v) => !!v || 'City is required']"
                    @input="payment.card.address_city = capitalizeFirstLetter(payment.card.address_city)"
                    ></v-text-field>
                </v-col>
                <v-col cols="3">
                    <v-text-field
                    outlined
                    dense
                    v-model="payment.card.address_state"
                    label="State"
                    v-mask="'AAA'"
                    :rules="[(v) => !!v || 'State is required']"
                    @input="payment.card.address_state = payment.card.address_state.toUpperCase()"
                    ></v-text-field>
                </v-col>
                <v-col cols="3">
                    <v-text-field
                    outlined
                    dense
                    v-model="payment.card.address_postcode"
                    label="Postcode"
                    v-mask="'####'"
                    :rules="[(v) => !!v || 'Postcode is required']"
                    ></v-text-field>
                </v-col>
                <v-col cols="12">
                    <v-select
                    outlined
                    dense
                    v-model="payment.card.address_country"
                    :items="Countries"
                    label="Country"
                    :rules="[(v) => !!v || 'Country is required']"
                    />
                </v-col>
            </v-row>
          </v-form>
          <v-btn :disabled="processingpayment" block dark color="oug" @click="processpayment"
          >Process Payment</v-btn>
        </div>
         <div v-if="freetickets" >
            <v-btn :disabled="processingtickets" block dark color="oug" @click="processtickets"
            >Generate Tickets</v-btn>
        </div>

    </v-container>
</template>

<script>
import db from "../data/Database";
import axios from "axios";
import functions from "../data/Functions"

export default {
  data() {
    return {
      charge_token: null,
      currentState: null,
      processing: true,
      success: false,
      freetickets: false,
      error: false,
      expiry: "",
      number: "",
      cvc: "",
      amount: null,
      processingpayment: false,
      processingtickets: false,
      payment: {
        amount: null,
        description: null,
        email: null,
        card: {
            number: "",
            expiry_month: null,
            expiry_year: null,
            cvc: "",
            name: null,
            address_line1: null,
            address_city: null,
            address_postcode: null,
            address_state: null,
            address_country: null
        },
      },
      rules: {
        required: (value) => !!value || "Details Required.",
        cardnumber: (value) => value.length == 19 || "Must be 16 numbers",
        cvc: (value) => value.length == 3 || "Must be 3 numbers",
        expiry: (value) => value.length == 7 || "Must Enter MM / YY numbers",
        email: (value) => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || "Invalid e-mail.";
        },
      },
      Countries: ["AU - Australia", "NZ - New Zealand", "UK - United Kingdom", "US - United States" ],
      Testing: false,
      TestPayment: {}
    };
  },
  created() {
    db.currentState.get(1, (result) => this.loadState(result));
  },
  methods: {
    loadState(result) {
        this.currentState = result;
        this.payment.description = result.Competition.Name;
          this.amount = result.Amount.toFixed(2);
        if (Number(this.amount) === 0.00) {
            this.processing = false
            this.freetickets = true
        }
        this.Testing = (result.Parameters && result.Parameters.testing == 'true') ? true : false
        if (this.Testing) {
            this.payment = {
                    amount: this.amount,
                    description: result.Competition.Name,
                    email: 'Fred@me.com',
                    card: {
                        number: "4200 0000 0000 0000",
                        expiry_month: "05",
                        expiry_year: "26",
                        cvc: "452",
                        name: "Fred Smith",
                        address_line1: "34 Tree Street",
                        address_city: "Manly",
                        address_postcode: "4156",
                        address_state: "QLD",
                        address_country: "AU"
                    },
            }
            this.expiry = "05 / 26"
            this.number = "4200 0000 0000 0000"
            this.cvc=  "452"
        }
    },
    processpayment() {
        if (this.$refs.Payment.validate()) {
            this.payment.card.expiry_month = this.expiry.substr(0,2)
            const myArr = this.expiry.split(" / ");
            this.payment.card.expiry_year = Number('20' + myArr[1])
            this.payment.amount = Number(this.amount)*100
            this.payment.card.number = Number(this.number.replace(/ /g, ""))
            this.payment.card.cvc = this.cvc
            this.payment.card.address_postcode = Number(this.payment.card.address_postcode)
            this.payment.card.address_country = this.payment.card.address_country.substr(0,2)
            this.processPinPayment(this.payment);
        }
      },
    processtickets() {
        let payment = {}
              payment.token = 'Free Tickets'
        if (this.currentState.Competition.Pricing === 'Per Day') {
            this.createDayTickets(payment);
        }
        if (this.currentState.Competition.Pricing === 'Per Game') {
            this.createGameTickets(payment);
        }
    },
    processPinPayment(payment) {
        this.processingpayment = true ;
        this.$toast.info(`Payment being Processed - Please Wait!`, {
                    timeout: 6000,
                });
        let baseURL = ''
        if (this.Testing ) {
            baseURL = "https://server.ownurgoal.net.au/pin/Test_Payment";
        } else {
            baseURL = "https://server.ownurgoal.net.au/pin/Payment";
        }
        // Process PIN Payment
        axios
            .post(baseURL, payment)
            .then((response) => {
                this.$toast.success(`Payment Successfull - Issuing Tickets now!`, {
                    timeout: 1000,
                });
                if (this.currentState.Competition.Pricing === 'Per Day') {
                    this.createDayTickets(response.data.payload);
                }
                if (this.currentState.Competition.Pricing === 'Per Game') {
                    this.createGameTickets(response.data.payload);
                }
            })
            .catch((error) => {
                console.log(error)
                if (error) {
                    let err_message = "" ;
                    switch (error.response.data.data.error) {
                        case "card_declined":
                        case "insufficient_funds":
                        case "invalid_cvv":
                        case "invalid_card":
                        case "processing_error":
                        case "suspected_fraud":
                        case "gateway_error":
                        case "unknown":
                            err_message = error.response.data.data.error_description ;
                            break;
                        case "invalid_resource":
                            switch (error.response.data.data.messages[0].code) {
                                case "card_expiry_month_invalid":
                                    err_message = "Card's expiry is in the past" ;
                                    break;
                                case "card_cvc_invalid":
                                    err_message = error.response.data.data.messages[0].message ;
                                    break;
                                default:
                                    err_message = "Unknown Error with this Card" ;
                                    break;
                            }
                            break;
                        default:
                            err_message = "Unknown Error with this Card"
                            break;
                    }
                    this.$toast.error(`Payment Failed: ${err_message}`, {
                        timeout: 6000,
                    });
                }
                this.processingpayment = false ;
            });
    },
    formatDate(date) {
      if (!date) return null;
      date = date.substr(0, 10);
      const [day, month, year] = date.split("/");
      return `${year}-${month}-${day}`;
    },
    createDayTickets(payment) {
        let tickets = [];
        let People = this.currentState.People;
        let Days = this.currentState.Days;
        const baseURL = "https://server.ownurgoal.net.au/tickets/InsertTickets";

        People.forEach(person => {
            Days.forEach(day => {
                tickets.push(
                    {
                        Person: person.person,
                        Email: person.email,
                        Phone: person.phone,
                        GameId: 0,
                        GameDate: functions.formatDate(day.date, 'YYYY-MM-DD'),
                        GameTime: "12:00:00",
                        GameDetail: `Day Ticket for - ${day.day}`,
                        Ticket: person.ticket,
                        Paymentid: payment.token,
                        Home: this.currentState.Team.Detail,
                        Away: this.currentState.Team.Detail,
                        Sub_Venue: this.currentState.Competition.Venue,
                        Association: this.currentState.Competition.Association,
                        Team: this.currentState.Team.Detail,
                        Competition: this.currentState.Competition.Name,
                        PhotoReg: person.photoReg,
                        PhotoPlayer: person.photoPlayer,
                    }
                )
            });
        })
        // Add Tickets to OUG DB
        axios
            .post(baseURL, tickets)
            .catch((error) => {
                console.log(error);
            });
        this.processingpayment = false ;
        this.$router.push(`/PaySuccess/${payment.token}` );
    },
    createGameTickets(payment) {
        let tickets = [];
        let People = this.currentState.People;
        let Games = this.currentState.Games;
        const baseURL = "https://server.ownurgoal.net.au/tickets/InsertTickets";

        People.forEach(person => {
            Games.forEach(game => {
                tickets.push(
                    {
                        Person: person.person,
                        Email: person.email,
                        Phone: person.phone,
                        GameId: game.id,
                        GameDate: this.formatDate(game.Date),
                        GameTime: game.Start_Time,
                        GameDetail: game.Display,
                        Ticket: person.ticket,
                        Paymentid: payment.token,
                        Home: game.Home_Team_Name,
                        Away: game.Away_Team_Name,
                        Sub_Venue: game.Sub_Venue,
                        Association: this.currentState.Competition.Association,
                        Team: this.currentState.Team.Detail,
                        Competition: this.currentState.Competition.Name,
                        PhotoReg: person.photoReg,
                        PhotoPlayer: person.photoPlayer,
                    }
                )
            });
        });
        // Add Tickets to OUG DB
        axios
            .post(baseURL, tickets)
            .catch((error) => {
                console.log(error);
            });
        this.processingpayment = false ;
        this.$router.push(`/PaySuccess/${payment.token}` );
    },
    capitalizeFirstLetter: (string) => {

        if (!string) { return '' }
        //split the above string into an array of strings 
        //whenever a blank space is encountered
        const arr = string.split(" ");

        //loop through each element of the array and capitalize the first letter.
        for (var i = 0; i < arr.length; i++) {
            arr[i] = arr[i].charAt(0).toUpperCase() + arr[i].slice(1);
        }

        //Join all the elements of the array back into a string 
        //using a blankspace as a separator 
        const newstring = arr.join(" ");

        return newstring;
    },
  },
  computed: {},
};
</script>

<style lang="scss" scoped>


.flex-item {
  padding: 0px;
  margin: 1px;
//   border: 1px solid #962283;
}

</style>